var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptanceBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 979.576,
    height: 1010.577,
    viewBox: "0 0 979.576 1010.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7569",
    "data-name": "Group 7569",
    transform: "translate(19699.763 2061.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9408",
    "data-name": "Path 9408",
    d: "M436.74,416.846C789.331,371.025,799.3,144.67,780.4,29.66A211.921,211.921,0,0,1,636.518,205.383c-90.152,32.991-185.345,47.081-277.445,60.713C216.113,287.287,92.4,305.5,46.347,389.7c-36.428,66.669-22.91,175.494,41.01,331.17C87.471,629.225,129.741,456.71,436.74,416.846Z",
    transform: "translate(-19506.178 -1806.572)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9409",
    "data-name": "Path 9409",
    d: "M264.351,1015.437c-59.682-75.719-209.057-292.909-142.732-496.7C178.9,343.819,346.255,310.714,481.083,284.023c60.254-11.455,112.375-22.223,142.044-43.186a8.591,8.591,0,1,1,9.852,13.975c-32.647,22.91-86.372,33.793-148.918,45.821C353.93,327.209,191.725,358.711,137.885,524.009c-65.295,200.81,88.892,417.2,143.763,485.7C31.581,426.3,487.842,574.412,831.5,448.405c226.24-82.821,147.428-422.239-79.385-441.941C740.658,5.433,727.6,4.86,714.2,4.86,471.232,5.089-6.221,173.6,7.525,539.359,17.148,792.29,193.214,958.39,264.351,1015.437Z",
    transform: "translate(-19706.998 -2065.861)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9410",
    "data-name": "Path 9410",
    d: "M352.468,71.84A203.671,203.671,0,0,0,286.715,83.3C85.447,151.11,38.71,293.384,38.71,293.384s160.373-42.957,311.7-42.957a629.151,629.151,0,0,1,78.7,4.582,152.8,152.8,0,0,0,18.443,1.26C570.46,256.269,502.3,71.84,352.468,71.84Z",
    transform: "translate(-19377.916 -1365.572)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptanceBg);
export default __webpack_public_path__ + "static/media/acceptance-bg.8ed69b619de2878f73a3f35e49dded7f.svg";
export { ForwardRef as ReactComponent };